const INIT_STATE = {
  isModalActive: false,
  showPrintTemplateDropdown: false,
  formDataId: '',
  recipient: '',
  subject: '',
  message: '',
}

export function EmailModalReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case 'EMAIL_MODAL_RESET':
      return { ...INIT_STATE };
    case 'EMAIL_MODAL_SHOW':
      return { ...state, isModalActive: true };
    case 'EMAIL_MODAL_HIDE':
      return { ...state, isModalActive: false };
    case 'EMAIL_MODAL_TOGGLE':
      return { ...state, isModalActive: !state.isModalActive };
    case 'EMAIL_MODAL_INITIALIZE':
      return { ...state, ...action.payload, isModalActive: true }
    case 'SET_EMAIL_RECIPIENT':
      return { ...state, recipient: action.payload }
    case 'SET_EMAIL_SUBJECT':
      return { ...state, subject: action.payload }
    case 'SET_EMAIL_MESSAGE':
      return { ...state, message: action.payload }
    case 'SET_EMAIL_CONTENT':
      return { ...state, ...action.payload }

    default:
      return state;
  }
}
